import React from 'react';
import PropTypes from 'prop-types';
import './SDUI.scss';

/**
 * Progress - Displays contract completion progress with field status
 * 
 * @param {number} percentage - Completion percentage (0-100)
 * @param {Object} fields - Field completion status map
 * @param {string} title - Progress title
 */
export const Progress = ({ percentage = 0, fields = {}, title = 'Contract Completion' }) => {
  const formatFieldName = (fieldId) => {
    return fieldId
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'complete':
        return '✓';
      case 'partial':
        return '◐';
      default:
        return '○';
    }
  };

  return (
    <div className='sdui-progress'>
      <div className='progress-header'>
        <span className='title'>{title}</span>
        <span className='percentage'>{percentage}%</span>
      </div>
      <div className='progress-bar'>
        <div className='progress-fill' style={{ width: `${percentage}%` }} />
      </div>
      {Object.entries(fields).length > 0 && (
        <div className='field-status'>
          {Object.entries(fields).map(([field, status]) => (
            <div key={field} className='field-item' data-status={status}>
              <span className='status-icon'>{getStatusIcon(status)}</span>
              <span className='field-name'>{formatFieldName(field)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

Progress.propTypes = {
  percentage: PropTypes.number,
  fields: PropTypes.objectOf(PropTypes.oneOf(['complete', 'partial', 'empty'])),
  title: PropTypes.string,
};

export default Progress;
